import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import Hero from "./Hero";
import { scrollToTop } from "../../utils/helper";

const Home = () => {
  Aos.init({
    duration: 1800,
    offset: 0,
  });
  useEffect(() => {
    scrollToTop();
    fetchIpAddress();
  }, []);

  const fetchIpAddress = async () => {
    try {
      const res = await fetch("https://ipinfo.io/json?token=eddc71319f6ccd");
      const data = await res.json();

      if (data && data.ip) {
        await fetch("http://localhost:5000/track", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
      }
    } catch (error) {
      console.error("❌ Error fetching IP info or sending to backend:", error);
    }
  };
  return (
    <div className="hidden-overflow">
      <Hero />
    </div>
  );
};

export default Home;
